<template>
  <div class="d-footer">
    <div class="d-footer__placeholder" :style="{height: footerHeight + 'px'}"></div>
    <div class="d-footer__content" ref="footerContent" :style="{background}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DFooter',
  props: {
    background: {
      type: String,
      default: '#ffffff'
    },
  },
  data () {
    return {
      footerHeight: 0
    }
  },
  mounted () {
    setTimeout(() => {
      console.log('-------- 获取高度开始 ----------');
      console.log(this.$refs.footerContent.clientHeight);
      console.log('-------- 获取高度结束 ----------');
      this.footerHeight = this.$refs.footerContent.offsetHeight
    }, 0)
  }
}
</script>

<style scoped lang="scss">
  .d-footer{
    width: 100%;
    z-index: 2000;
    position: relative;
    &__placeholder{
      width: 100%;
    }
    &__content{
      position: fixed;
      left: 0;
      bottom: 0;
      background: #ffffff;
      padding-bottom: var(--safe-area-inset-bottom);
      box-sizing: content-box;
      width: 100%;
    }
  }
</style>
